export default "__VITE_ASSET__DRmp1wfw__"